import { Operation, op } from "libs/transaction";
import { FcmTokenOrPushSubscription } from "libs/schema";

export type CreateSubscriptionProps = {
  id: string;
  userId: string;
  subscription: FcmTokenOrPushSubscription;
  ownerOrganizationId: string;
};

export function createPushNotificationSubscription(props: CreateSubscriptionProps): Operation[] {
  return [
    op.set("user_push_notification_subscriptions", {
      id: props.id,
      user_id: props.userId,
      subscription: props.subscription,
      owner_organization_id: props.ownerOrganizationId,
    }),
  ];
}
